// main imports
import React from 'react'
import moment from 'moment'

// styles
import styles from './Hero.module.css'

// components
import { NavLink, NavA } from './Link'
import Typewriter from './Typewriter'

const heroContent = [
  {
    h1: 'We build websites.',
    h2: 'We work with you to bring your digital presence to life.',
  },
  {
    h1: 'We build fast things.',
    h2:
      '53% of visits are abandoned if a mobile site takes more than 3 seconds to load.',
  },
  {
    h1: 'We help you build your brand image.',
    h2: 'We work with you to refine your brand messaging.',
  },
  {
    h1: 'We do personalized digital branding.',
    h2:
      '89% of U.S. marketers reported that personalization on their websites or apps resulted in an increase in revenue.',
  },
  {
    h1: 'We design web experiences.',
    h2:
      'Interactive, animated experiences drive more engagement with your customers.',
  },
]

const LINK_SHOPPER =
  'https://www.thinkwithgoogle.com/intl/en-cee/advertising-channels-tools/mobile/four-insights-how-shoppers-use-apps-and-mobile-sites/'

const LINK_CONSUMER =
  'https://www.thinkwithgoogle.com/advertising-channels/mobile-marketing/consumer-behavior-mobile-digital-experiences/'

const LINK_SPEED =
  'https://www.thinkwithgoogle.com/marketing-resources/data-measurement/mobile-page-speed-new-industry-benchmarks/'

const INTERNET_USAGE = 'https://www.internetworldstats.com/emarketing.htm'

const INTERNET_STATS = [0.9, 3.6, 5, 9.4, 10.6, 29.5, 51.7, 65.1, 70, 99]

const InlineChart = ({
  data,
  chartClass = 'dotline-extrathick',
  textStart,
  textEnd,
}) => {
  let chartString = '0'
  data.map(v => {
    let int = Math.ceil(v)
    chartString = chartString.concat(',' + int.toString())
  })

  return (
    <span className={'sparks text-highlight ' + chartClass}>
      {`${textStart || ''} {${chartString}}`}
      <span className="sparks ">{textEnd || ''}</span>
    </span>
  )
}

const AnimatedTextData = ({ interval = 5 }) => {
  const h1 = heroContent.map(v => v.h1)
  const h2 = heroContent.map(v => v.h2)

  return (
    <>
      <h1 className={styles.h1}>
        <Typewriter
          delay={interval}
          initialData={h1[0]}
          data={h1}
          random={false}
        />
      </h1>
      <h2 className={styles.h2}>
        <Typewriter
          delay={interval}
          initialData={h2[0]}
          data={h2}
          speed={3}
          random={false}
        />
      </h2>
    </>
  )
}

const HeroText = () => (
  <div className={styles.default}>
    <div className={styles.text}>
      <AnimatedTextData interval={6} />
      <div className={styles.break} />

      <h3 className={styles.h3}>
        Your{' '}
        <NavA
          href={LINK_CONSUMER}
          text="3.5 Billion"
          type="header"
          selected={LINK_CONSUMER}
          style={{ fontWeight: 600, fontSize: '1em' }}
        />{' '}
        customers expect{' '}
        <NavA
          href={LINK_CONSUMER}
          text="personalized"
          type="header"
          selected={LINK_CONSUMER}
          style={{ fontWeight: 600, fontSize: '1em' }}
        />
        ,{' '}
        <NavA
          href={LINK_SPEED}
          text="fast"
          type="header"
          selected={LINK_SPEED}
          style={{ fontWeight: 600, fontSize: '1em' }}
        />{' '}
        website experiences, while you want them to understand your brand and
        the value you bring to their lives. This is where{' '}
        <NavLink
          href="/about"
          text="we"
          type="header"
          selected="/about"
          style={{ fontWeight: 600, fontSize: '1em' }}
        />{' '}
        come in.{' '}
        <NavLink
          href="/projects"
          text="Check out some of our works."
          type="inverted"
          selected="/projects"
          style={{ fontWeight: 800, fontSize: '1em', padding: 1 }}
        />
      </h3>
      {/* <code>hero text here, use absolute positioning</code>
      <code>
        in the future, I plan to animate the text based on the content behind
        also a link to a related important chart
      </code>
      <code>content scroll behind, front text animates typewriter style</code> */}
    </div>
  </div>
)

export default HeroText
